import { jsx as p } from "react/jsx-runtime";
import { c as d } from "react/compiler-runtime";
import { Box as m, Typography as g } from "@mui/material";
const C = (a) => {
  const e = d(10), {
    selectedTime: t,
    onTimeChange: r,
    timeSlots: c
  } = a;
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    maxHeight: "184px",
    overflowY: "auto"
  }, e[0] = n) : n = e[0];
  let o;
  if (e[1] !== r || e[2] !== t || e[3] !== c) {
    let l;
    e[5] !== r || e[6] !== t ? (l = (s, f) => {
      const x = s === t;
      return /* @__PURE__ */ p(m, { sx: {
        padding: "8px 33px",
        textAlign: "center",
        backgroundColor: x ? "#F7F7F7" : "transparent",
        margin: "0px 10px",
        cursor: "pointer",
        ":hover": {
          backgroundColor: "#F7F7F7"
        }
      }, onClick: () => r(s), children: /* @__PURE__ */ p(g, { sx: {
        fontSize: "12px",
        fontWeight: "500"
      }, children: s }) }, f);
    }, e[5] = r, e[6] = t, e[7] = l) : l = e[7], o = c.map(l), e[1] = r, e[2] = t, e[3] = c, e[4] = o;
  } else
    o = e[4];
  let i;
  return e[8] !== o ? (i = /* @__PURE__ */ p(m, { sx: n, children: o }), e[8] = o, e[9] = i) : i = e[9], i;
};
export {
  C as TimePickerComponent
};
